export const TYPEFORM_URL_JOTAPRO_TRIAL =
    'https://jota7.typeform.com/to/V2cEJGav?utm_source=site&utm_campaign=jota_pro_trial'
